import React from "react";

interface Props {
  fillColor?: string;
  size?: string;
}
const PlayArrow: React.FC<Props> = ({
  size = "42",
  fillColor = "#fff",
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 46 42"
      height={size}
      width={size}
      {...props}
    >
      <path fill={fillColor} d="M46 21 0 42V0Z" data-name="Polygon 5" />
    </svg>
  );
};

export default PlayArrow;
